let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8miHS"), load("awqhH"), load("8hbZ5"), load("VoVRZ"), load("c6MKV"), load("fwbht"), load("3yFtm")]).then(() => parcelRequire('dQUV0'));